import React, { useState, useRef } from "react";
import RequestService from "../../services/request.service";

import { useNavigate } from "react-router"
// import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
import { Form, Button, Col, Row, Modal, Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import { toast } from 'react-toastify'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


// import { confirm } from '../../widgets/confirm'

import './tramites.scss';

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

import moment from 'moment'


import Dialog from '../../services/Dialogs'
// import { SERVER_ } from  '../../config';


import AuthService from "../../features/auth/auth.service";


const curp2date = (curp) => {
  var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ );
  //miFecha = new Date(año,mes,dia) 
  var anyo = parseInt(m[1],10)+1900;
  if( anyo < 1950 ) anyo += 100;
  var mes = parseInt(m[2], 10)-1;
  var dia = parseInt(m[3], 10);
  return (new Date( anyo, mes, dia ));
}


const Tramites = () =>{

  let navigate = useNavigate();

  // let { uuid_departamento } = useParams();
  const uuid_departamento = "0538a87e-9321-481f-b0ad-ef2889bcc6f7"

  const dialog = new Dialog();

  const currentUser  = AuthService.getCurrentUser();


  const cancelarTramite = async (event)=>{

    try{
      // if (await confirm({ confirmation: '¿Estás seguro? Perderas la información capturada' })) {
      if (await dialog.confirm( '¿Estás seguro? Perderas la información capturada', event ) ){
          window.location.reload()
      } 
    } 
    catch(e){
      toast.error(JSON.stringify(e))
    }

  }


  const [ depto, setDepto ] = useState<any>({})


    const cargarDeptoAndRequisitos = async () =>{
      try{
          let reqs = await RequestService.getEndPoint('depto/'+uuid_departamento)
          setDepto( reqs.data )

            let req2 = await RequestService.getEndPoint('tramite/requisitos/'+uuid_departamento)
            // console.log(formReferenciaMain.current.values.iddepartamento)
            setRequisitosTramite(req2.data)
      } 
      catch(e){
        toast.error('Error al cargar la lista de departamentos.')
      } 
  }

  const [ afores, setAfores ] = useState<any>([])
    const cargarAfores = async () =>{
      try{
          let reqs = await RequestService.getEndPoint('afores')
          setAfores( reqs.data )
      } 
      catch(e){
        toast.error('Error al cargar la lista de afores.')
      }
  }

  const [ asistentes_asesores, setAsistentes ] = useState<any>([])
    const cargarAsistentes = async () =>{
      try{
          let reqs = await RequestService.getEndPoint('asistente/lista_asesores')
          setAsistentes( reqs.data )
      } 
      catch(e){
        toast.error('Error al cargar la lista de afores.')
      }
  }

  React.useEffect(() => {
    cargarDeptoAndRequisitos()
    cargarAfores()
    cargarAsistentes()
  }, []);


  const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
  const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u


const schema = yup.object().shape({
          iddepartamento: yup.number().required('El departamento es un campo obligatorio'),
          folio: yup.string().nullable(true),
          nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El nombre es obligatorio'),
          paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El primer apellido es obligatorio'),
          materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").nullable(true),
          // sexo: yup.string().required('El sexo es un campo obligatorio'),
          curp: yup.string().matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),

          // monto: yup.number().when("iddepartamento", {
          //         is: (iddepartamento)=>{
          //           if(iddepartamento === 1 || iddepartamento === 3) return yup.number().required("El monto es obligatorio")
          //         },
          //         then: yup.number().required('Debes ingresar un monto'),
          // }),
          fecha_tramite: yup.date().required(),
        })



const schema_persona = yup.object().shape({

          nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El nombre es obligatorio'),
          paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El primer apellido es obligatorio'),
          materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").nullable(true),
          curp: yup.string().matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),
          seguro_social: yup.string().matches(/^\d{11}$/,"Formato no valido").required('Este campo es obligatorio'),
          rfc: yup.string().required('Este campo es obligatorio'),

          email: yup.string().email('Formato de Email no valido').nullable(true),
          telefono: yup.string().matches(/^\d{10}$/,"Formato no valido").nullable(true),
          celular: yup.string().matches(/^\d{10}$/,"Formato no valido").nullable(true),


          direccion: yup.string().nullable(true),
          colonia: yup.string().nullable(true),
          cp: yup.string().matches(/^\d{5}$/,"Formato no valido").nullable(true),


        })



const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzÑñ';

const generateString =  (length) => {
    let result = ' ';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result.toUpperCase();
}

  const [showModalSolicitante, setShowModalSolicitante] = useState(false);

  const handleCloseModalSolicitante = () =>{
    setShowModalSolicitante(false);
  }
  const handleShowModalSolicitante = () =>{
     setShowModalSolicitante(true);
  }



  const [ CIUDADANO_TRAMITE, setCiudadano ] = useState<any>(null)
  const [ SOLICITANTE, setSolicitante ] = useState<any>({
    curp : ""
  })



  const [ verifico_existencia_ciudadano, setVerificaExistencia ] = useState(false)
  const [ ciudadano_existe, setCiudadanoExiste ] = useState(false)
      



  const verificacion_solicitante = async (curp:string) => {

    try{
      let req = await RequestService.getEndPoint('verificacion_solicitante/'+curp)
      // console.log(req.data)
      setVerificaExistencia(true)
      if(!req.data.existe) toast.warning('Debes capturar la información de este solicitante')
      if(req.data.existe){
        setSolicitante(req.data.solicitante)
        setCiudadanoExiste(true)
      }
    }
    catch(e){
      toast.error(JSON.stringify(e))
    }

  }



// const handleSave = async (values:any) => {
 
//     try{

//       if( await dialog.confirm('¿Estás seguro?', {}) ){
//         console.table(values);
//         // await RequestService.create('registro-diario-tramite',{ tramite_data : values })

//         //   if(await dialog.confirm('¿Deseas seguir capturando?', {})){
//         //     window.location.reload()
//         //   }
//         //   else{
//         //     navigate('/mi_reporte')
//         //   }
//       }


//     }
//     catch(e){
//       console.log(e)
//        toast.error('Problemas para dar de alta al tramite');  
//      }

                  
// }




    const actualizarDatosCiudadano = async (e:any) =>{

        try{

        await dialog.open({
          accept: 'Continuar',
          dialogClass: '',
          message: '¿Estás seguro?',
          // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `<p>Los datos del solicitante deben guardarse para poder avanzar</p>`
        })
        let dialogo : any = await dialog.waitForUser()


          if(dialogo){
            let req = await RequestService.update('tramites/actualizar_datos_ciudadano/'+ SOLICITANTE.uuid ,
                  {
                    email : SOLICITANTE.email, 
                    celular : SOLICITANTE.celular, 
                    telefono : SOLICITANTE.telefono,
                    direccion : SOLICITANTE.direccion,
                    colonia : SOLICITANTE.colonia,
                    cp : SOLICITANTE.cp
                  }
              )
            toast.warning('Se actualizo la información del solicitante')
            // continuarTramite(e)

            setCiudadano(SOLICITANTE)
            setShowModalSolicitante(false);


          }

        }
        catch(e:any){
          toast.error(e.response.data)
        }

    }



    const agregarNuevoSolicitante = async ( allValues : any ) =>{

      try{
        // console.log(allValues)
         let req = await RequestService.create('tramite/alta_solicitante', allValues )
         // console.log(req)
         toast('El Cliente fue agregado, ahora puedes continuar con el tramite')

            setCiudadano(req.data.solicitante)
            setShowModalSolicitante(false);

      }
      catch(e){
        toast.error('Error al agregar el nuevo solicitante')
      }


    }


    const [ requisitos_del_tramite, setRequisitosTramite ] = useState<any>([])


    // const continuarTramite = async (e:any) =>{


    //       await dialog.open({
    //         accept: 'Continuar',
    //         dialogClass: '',
    //         message: 'Cambios realizados',
    //         // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
    //         // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
    //         target: e.target,
    //         template: `<p>Los datos del ciudadano fueron registrados</p>`
    //       })
    //       let dialogo : any = await dialog.waitForUser()


    //       if(dialogo){
    //         // toast('el tramite continua')
    //         // ciudadano_existe
    //         setCiudadano(SOLICITANTE)
    //         setShowModalSolicitante(false);

    //       }
    //       else{
    //         toast.warning('UPS')
    //       }
    // }





    const seleccionarCiudadanoOtraVez = async () =>{
          if(await dialog.confirm('Estas seguro?', {})){
            setSolicitante({ curp : SOLICITANTE.curp })
            setVerificaExistencia(false)
            setCiudadanoExiste(false)
            toast.warning('Ahora debes volver a identificar al solicitante')
          }

    }


    const formatDate = (date) => moment(date).format('DD[-]MMMM[-]YYYY').toUpperCase();
    const getAge = (dateString) => {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }


    const formReferenciaMain : any = useRef();
    const formRef : any = useRef();



  const handleFileRead = async (event:any, index: number) => {
    const file = event.target.files[0]
    const base64 = await convertBase64(file)
    var RT = [ ... requisitos_del_tramite ]
    RT[index].anexo = base64
    setRequisitosTramite(RT)
    // console.log(base64)
  }


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }



  const [ anexo_preview, setAnexoPreview ] = useState<string>('')
  const [showPreview, setShowPreview] = useState<boolean>(false);

  const handleClosePreview = () => {

    setShowPreview(false);
  }

  const previewPDF = (base64:string)=>{
    setAnexoPreview(base64)
    setShowPreview(true);
  }


  const deleteFileRequisito = (index:number) => {
    var RT = [ ... requisitos_del_tramite ]
    delete RT[index].anexo
    setRequisitosTramite(RT)

  }


  const [ estrategias_extra, setExtraDataEstrategias ] = useState<any>({
    fecha_baja_anterior : null,
    fecha_alta_anterior : null,

    sindo : null,

    semanas_cotizadas: "",
    monto_aseguramiento: "",
    monto_rcv: "",
    anticipo : "",
    idafore : "",
    traspaso_afore : false,
    idafore_anterior : "",
  })


  const [ enviandoTramite, setEnviandoTramite ] = useState<boolean>(false)

  const crearExpediente =  async (e) =>{

    setEnviandoTramite(true)

    let se_puede_enviar = true

      if(!usuario_libre){

        if(formReferenciaMain.current.values.folio === ""){
          toast.error('Falta agregar el Folio')
          se_puede_enviar = false
          setEnviandoTramite(false)
        }
        if(!estrategias_extra.fecha_baja_anterior){
          toast.error('Aun te falta la fecha de baja del trabajo anterior')
          se_puede_enviar = false
          setEnviandoTramite(false)
        }
        if(!estrategias_extra.fecha_alta_anterior){
          toast.error('Aun te falta la fecha de alta del trabajo anterior')
          se_puede_enviar = false
          setEnviandoTramite(false)
        }

        if(estrategias_extra.idafore === ""){
          toast.error('Aun te falta el AFORE en el que está registrado')
          se_puede_enviar = false
          setEnviandoTramite(false)
        }

        if(currentUser.rol === 'ROLE_ASISTENTE'){
            if(formReferenciaMain.current.values.uuid_usuario_ayudo === null){
              toast.error('Falta seleccionar el asistente')
              se_puede_enviar = false
              setEnviandoTramite(false)
            }
          }



      }

    
    // if(!estrategias_extra.fecha_alta_anterior){
    //   toast.error('Aun te falta la fecha del SINDO')
    //   se_puede_enviar = false
    // }

    let falta_anexos_obligatorios = false
    for (var i = 0; i < requisitos_del_tramite.length; ++i) {
      if(!requisitos_del_tramite[i].anexo && requisitos_del_tramite[i].obligatorio) falta_anexos_obligatorios = true
    }

  if(usuario_libre){
    falta_anexos_obligatorios = false
    se_puede_enviar = true
  }
  // console.log('le faltan anexos obligatorios',falta_anexos_obligatorios)

    if(!falta_anexos_obligatorios && se_puede_enviar){
      toast('El Trámite cumple con todos los requisitos')

        dialog.open({
          accept: 'Sí, Crear Expediente',
          cancel: 'Espera',
          dialogClass: 'aceptar',
          message: 'Verifica la información',
          // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `
          <b className="nm"><small>Solicitante</small></b>
          <p className="nm">`+CIUDADANO_TRAMITE.nombres+` `+CIUDADANO_TRAMITE.paterno+` `+CIUDADANO_TRAMITE.materno+`</p>
          <b className="nm"><small>CURP</small></b>
          <p className="nm">`+CIUDADANO_TRAMITE.curp+`</p>
          
          <b className="nm"><small>Número de Celular</small></b>
          <p className="nm">`+CIUDADANO_TRAMITE.celular+`</p>

          <b className="nm"><small>Correo Electrónico</small></b>
          <p className="nm">`+(CIUDADANO_TRAMITE.email||'No proporcionado')+`</p>
          `
        })
        let response = await dialog.waitForUser()

        // console.log("response???")
        // console.log(response)
        if(response){
          // let idusuario_ayudo = null

          try{

          let respuesta_nuevo_folio = await RequestService.create('tramite/nuevo_folio',{ 
                                                                                    folio : formReferenciaMain.current.values.folio, 
                                                                                    uuid_usuario_ayudo : formReferenciaMain.current.values.uuid_usuario_ayudo, 
                                                                                    uuid_departamento : formReferenciaMain.current.values.iddepartamento, 
                                                                                    solicitante : CIUDADANO_TRAMITE, 
                                                                                    anexos : requisitos_del_tramite, 
                                                                                    data_depto : estrategias_extra })


            await dialog.open({
              accept: 'Si',
              cancel: 'No',
              dialogClass: '',
              message: 'Espera',
              // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
              // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
              target: e.target,
              template: `¿Deseas seguir capturando?`
            })
            let dialogo : any = await dialog.waitForUser()
            if(dialogo){
              window.location.reload()
            }
            else{
              navigate('/mi_reporte')
            }

          }
          catch(e:any){
            setEnviandoTramite(false)
            if(e.response.data.code==='E_UNIQUE') toast.warning("El Folio que tratas de ingresar ya existe. Verifica tu información.");
            else toast.warning('Error al intentar crear el registro. Se recomienda verificar su conexión a internet y volvar a intentar la captura. Si el problema persiste contacte con soporte.')
            // console.log(e.response.data.message)
          }



        }
        else{
          toast.warning('Verifica tu información antes de continuar')
          setEnviandoTramite(false)
        }


    }
    else{
      toast.warning('Debes anexar todos los Requisitos antes de poder crear el Nuevo Expediente')
      setEnviandoTramite(false)
    }


  }


  const cancelarCaptura = async (e) => {
      dialog.open({
          accept: 'Sí, borrar &nbsp; <svg viewBox="0 0 1000 1000" style="width: 20px; height: 20px" xmlns="http://www.w3.org/2000/svg"><path fill="#FFF" style="fill: var(--svg-status-bg, #fff);" d="M0 281.296l0 -68.355q1.953 -37.107 29.295 -62.496t64.449 -25.389l93.744 0l0 -31.248q0 -39.06 27.342 -66.402t66.402 -27.342l312.48 0q39.06 0 66.402 27.342t27.342 66.402l0 31.248l93.744 0q37.107 0 64.449 25.389t29.295 62.496l0 68.355q0 25.389 -18.553 43.943t-43.943 18.553l0 531.216q0 52.731 -36.13 88.862t-88.862 36.13l-499.968 0q-52.731 0 -88.862 -36.13t-36.13 -88.862l0 -531.216q-25.389 0 -43.943 -18.553t-18.553 -43.943zm62.496 0l749.952 0l0 -62.496q0 -13.671 -8.789 -22.46t-22.46 -8.789l-687.456 0q-13.671 0 -22.46 8.789t-8.789 22.46l0 62.496zm62.496 593.712q0 25.389 18.553 43.943t43.943 18.553l499.968 0q25.389 0 43.943 -18.553t18.553 -43.943l0 -531.216l-624.96 0l0 531.216zm62.496 -31.248l0 -406.224q0 -13.671 8.789 -22.46t22.46 -8.789l62.496 0q13.671 0 22.46 8.789t8.789 22.46l0 406.224q0 13.671 -8.789 22.46t-22.46 8.789l-62.496 0q-13.671 0 -22.46 -8.789t-8.789 -22.46zm31.248 0l62.496 0l0 -406.224l-62.496 0l0 406.224zm31.248 -718.704l374.976 0l0 -31.248q0 -13.671 -8.789 -22.46t-22.46 -8.789l-312.48 0q-13.671 0 -22.46 8.789t-8.789 22.46l0 31.248zm124.992 718.704l0 -406.224q0 -13.671 8.789 -22.46t22.46 -8.789l62.496 0q13.671 0 22.46 8.789t8.789 22.46l0 406.224q0 13.671 -8.789 22.46t-22.46 8.789l-62.496 0q-13.671 0 -22.46 -8.789t-8.789 -22.46zm31.248 0l62.496 0l0 -406.224l-62.496 0l0 406.224zm156.24 0l0 -406.224q0 -13.671 8.789 -22.46t22.46 -8.789l62.496 0q13.671 0 22.46 8.789t8.789 22.46l0 406.224q0 13.671 -8.789 22.46t-22.46 8.789l-62.496 0q-13.671 0 -22.46 -8.789t-8.789 -22.46zm31.248 0l62.496 0l0 -406.224l-62.496 0l0 406.224z"/></svg>',
          cancel: 'Espera',
          dialogClass: 'cancelar_captura',
          message: '¿Estás seguro?',
          // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
          // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
          target: e.target,
          template: `<p>La información que estás capturando se perdera</p>`
        })

      let response = await dialog.waitForUser()

      if(response){
        toast.error('Esto se va a eliminar')
        setTimeout(()=>{
          navigate(0)
        },2000)
      }
  }



  const usuario_libre = 
['f7fc9157-54ee-4dca-86a9-c932f7e07310', 'b4749ae3-1d41-4239-bf1a-4beb891067a9', '792f9a3f-c6a2-4e9b-b090-6225988a0a5e', 'd1e125ed-8b4b-4f81-811d-bf7065422a98', '398ddc30-0ded-40c0-a701-288554577470', '28bae881-572b-4ab0-9f46-ae4b932dbeb8', '39f2148f-3cf3-47c6-bede-44308fd9b30b', '23973b03-cbe3-48cc-9ca4-c1c26ed52ae3', 'd690e643-f76f-407f-8c83-adc61bfe7e34', 'de55d200-e64f-44b4-acc4-9148ef5d7369', '217d0b55-ecf9-4bc8-beab-8bfdbb4235c8', '44baba7f-f2f0-4d72-848f-399d9acf57f9', '18ee6ee1-5bec-4299-9de8-4534cd0b8131', '58093a65-ac3e-4f58-8bb1-c5d7a3f59320', '3f45991a-8af8-4b98-8e54-fdebaf75c3fd', '58bf5129-89d5-4bec-a423-d750448e30d3', '75762ff1-7024-4a84-be7a-58c21761f855', '6f071609-ec1a-4410-83a2-ad53b747b0bb', '2a59ceaf-e025-4adf-91a4-bc283041d3d3', 'b7f5ca03-aac1-4888-80c6-65d7b5d839d5', '373135cb-5dc8-40c7-a989-5636a7841703', '78ced32d-fa9f-43a8-9644-cc62561b4db7', 'ba302ef9-35c4-4265-8630-b3ab73e889dd', 'baf73114-12d7-4e36-84d3-44cac75fab9f', 'c48fec89-aaee-4ece-9c4f-bf5a353b2a67', '71aad1d3-5f6b-41d1-9626-3627546a4cca', 'f0f1ec0f-ea58-4347-a707-6e8d6c01046d', 'cd6fd9cb-1508-4d6a-af47-5bcc209fd85b', '1ecb6697-21d9-401d-9ccb-1603a67a13e2', 'a98e398f-6744-416f-b698-f1229e0badbc', 'c0bfb43f-a4d3-4cd4-9fae-aa1f4a21a583', 'b0cf31b1-bb11-46cf-83dc-528530180b15', '663468f6-7347-4084-b946-4d1f4829112b', '554a5bde-5a56-4cdb-89c3-90d64ca8448e', '9745e9a6-d428-4d01-8768-19bb2ba84020', '5b871328-8a68-4e7a-8fb2-a94650d71c09', 'bf3358c9-555d-4e2f-bce1-a92977f0e40e', '70794477-e4aa-4c64-8ad6-91b67e82a90f', '87cc8119-e1dc-4f39-91f7-517b3f413fbd', '9e8800c8-a577-4259-aa37-0f6eb5c82eaa', 'ccc6eb1d-02e7-40b0-8176-51ef92edf7ec', '8bac9093-e42e-4f4c-9504-b8323fac1b8e', '0c5e1187-5e74-4519-8402-f2d75bd47408', 'ee9207e9-a358-455d-8970-2bc871da2238', '63fa0ae0-6f94-4af3-9ec5-55cdd90ce9b1', '06049d66-a917-4b24-b7cf-013da07d1781', 'ba9f5766-cdf2-4df7-ad05-c85eb8fc1b8e', '00cad0d4-8386-4d0b-a71d-20bb4295c833', 'b5743b7a-7ec6-489f-9760-d5d9523f04d6', '5f82996e-3939-4df7-9ea7-5a7fe6cc7b45', '444b82b6-3987-4c81-9c6f-08d729a169c2', 'd533e9dd-294f-4871-8bc4-bd7c4ff72771', '26fd4c56-79ba-4a81-b8e8-dd33e4da46d3', '43d6d50f-b8b7-430f-96e4-0fba0e392a35', '61ea9366-5d9a-4eea-9976-d50d295c5739', '2066ddc0-ea53-4914-ac5d-c5eb47e070f3', '6b43a889-bec9-4326-94bd-1a0a2c716590', 'ccdfb18e-12a6-456e-bdfa-5f5fee2ad166', 'eb447688-76f9-4371-994d-c3f6bf4124a1', '867c763f-07e1-4aef-b096-c8f472e2e195', 'bd2b8cfe-59a2-40d0-bebc-35372c4ae74f', '0c86d8f6-bbcd-4ac3-8648-472b89a97efd', '1067f884-ec84-418b-8a7a-014f34b29c4e', 'efd4328a-4958-488c-9a22-9dbd01352fdb', '319f7cab-5b63-4b1c-b569-9f623ef14f42', '020b7f3b-0b91-4049-b04a-4501108e5154', 'c61359ee-865c-435e-bc05-d0ea1001bada', 'f8b57902-2afa-4a1f-b1cc-b252804fa3a3', 'e2b73e1c-da7e-4a14-b6f9-312934afff25', '2900d3b3-02dc-44fe-870f-57c9efca5ed8', '78831440-4896-4dc5-846d-01512df237db', 'f5e90b29-78ff-475c-97b4-d9830d1be500', '1c197f6c-59e0-443a-b6d9-3ced38cc5354', '94ac515b-68fe-47bc-a155-74b431f2a831', '2433542a-95bc-4218-bcaf-0fc9784cd0e1', '461c6231-0f4b-40cb-976d-d7c9167d8868', '7c4efa7f-4a13-47ec-a606-1c979f7df56e', '2caf1a25-4bb6-4cfd-b124-073ba880d5c2', '0f0cb04e-be8f-4d14-8eaf-c70600ef54e9', '10f51352-e6fe-4cd9-a68d-a163efbf5501', '5b0e2a1a-0acb-4362-a412-39c548045401', '14fadde8-0a8c-4215-a404-6b4f1cc31350', '6101556b-de5c-4607-9d20-c4b02d5115e3', '80fc6047-04eb-4eeb-aa52-dead45bcc13d', 'd739aea0-0060-4f93-b630-fd6cb6f57bdb', 'ef8e100e-f3b9-4003-99ef-60197d645ec3', 'a85a52cb-3e02-4585-af51-8ba7b5f289ca', 'bf965789-3d5d-4b78-8a1e-260025909241', '21d0dfe8-6441-4b93-8298-986d95fdc8c8', '69143cfa-c285-4375-a441-1f82987a066b', '99b18142-7312-4add-90f8-0e3cbe9653df', 'adb9163f-c6d0-4c4f-821e-287c26688e16', '10cd6798-3a9e-4688-9ebe-5bb25ef0e6c8', '055d5e08-11c7-46a2-976f-2d10e6e5f547', 'd77b6f37-04c6-462f-a9e1-ba203f2ded5d', '3fbbedd2-98c0-4568-88f8-c45c7c6e5014', 'ddcecea5-907c-4864-b150-f04474a08940', '6d5896a9-bea3-4db7-a5a9-827e2ef9f055', '779e8742-68d4-4e24-b62f-689dc6a34815', '2cf4ae0f-0c1b-4e74-b875-683914472dd1', '25677bc3-4516-4457-8c2b-bf1f872b9085', 'f404b6d3-e639-4c40-bc48-e368d12e917b', 'd08184e3-6b70-435f-92e5-f3d594efa4ef', '2f839d57-2459-4ca7-8a14-549ac62b5331', 'c08dce61-055c-454b-8a02-7981493266fe', '0dc3f3dc-6733-4f2d-bbc5-3a11e28a8894', 'd8571343-6a94-4d2f-a775-8e15651f3a7f', 'b0c7ea7a-d5ab-4619-b4b5-4809a9453e90', '9dfa0b4a-c881-422b-8f45-911c0c1cfb93', 'ee148e5d-e88a-4169-a123-aa09e0cee51c', '19fe4fd6-8ce4-44d7-ad08-f2d32140c0bf', '15bc3c76-ea03-4bcc-9419-03ebe5752f8c', '636623b0-f20d-4169-925a-76c2194ea05d', 'ef6a7cd1-bca3-40ea-b239-db74297a7bd6', '149e74d2-55a3-4b28-a9ea-184e59d8d8aa', 'e8a1d849-918d-4da8-a2df-5a3d9dd96ef5', '367ef3d4-5210-47b0-93f5-e2988b7f3bc7', '59a30004-40c9-4fdc-ace4-f5c3a0994816', '83b6c061-41e1-43c7-8fe6-6608575ab677', '78a66e90-4e1a-4099-8b2e-67e5d37b33c4', '85ac8f31-ec71-46e6-898f-c69330dff9fa', 'd39e0f98-4bd0-467a-969c-af7d3aeb4bd4', '7a696028-5a4b-4bcb-9972-0793914fd539', '5e20dba2-2b03-40d6-b350-dccc3f39ba06', 'a5ed5f81-a6a0-4871-8771-7a2b3d7f0b74', '7cafa74a-3173-4715-8f68-c9c570e4e1d3', '60bc205e-8920-4902-919f-646c19f259d2', '1e5cff72-f414-48b6-b1ed-5318b4f22175', '4abf1a02-4127-4c14-89f7-bf39e6e4bb97',
"082f1106-5d73-45e0-a28b-9441178e141d"
  ].indexOf(currentUser.uuid) > -1 



      return (

    <React.Fragment>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">

                      <div className="mt-4">
                      

                            <Formik
                              innerRef={formReferenciaMain}
                              validationSchema={schema}
                              onSubmit={ async (values : any, { setSubmitting }) => {
                                try{

                                  // console.log('???')
                                  if( await dialog.confirm('¿Estás seguro?', {}) ){
                                    // console.table(values);
                                    await RequestService.create('registro-diario-tramite',{ tramite_data : values, anexos:  [] })

                                      if(await dialog.confirm('¿Deseas seguir capturando?', {})){
                                        window.location.reload()
                                      }
                                      else{
                                        navigate('/mi_reporte')
                                      }
                                  }


                                }
                                catch(e:any){
                                  console.log(e.response.data)
                                   toast.error(e.response.data);
                                 }

                              }}
                              initialValues={{

                                  // iddepartamento : null,


                                  // nombres : "",
                                  // paterno : "",
                                  // // materno : "",
                                  

                                  // // nombres : (generateString(6)).trim(),
                                  // // paterno : (generateString(6)).trim(),
                                  // // materno : (generateString(6)).trim(),
                                  
                                  // folio : usuario_libre ? [...Array(3)].map(() => 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)]).join('') + [...Array(4)].map(() => Math.floor(Math.random() * 10)).join('') : "",
                                  folio : "",
                                  uuid_usuario_ayudo : null,
                                  // // curp : ((generateString(1)) +'APC'+ (Math.floor(Math.random() * 6) + 1) + (Math.floor(Math.random() * 6) + 1) +'1225MCCNNT0'+(Math.floor(Math.random() * 6) + 1)).trim(),

                                  iddepartamento : uuid_departamento,
                                  // monto : "",
                                  // fecha_tramite : moment().format('YYYY-MM-DD'),
                                  // // folio : "GMEF-2022-"+(Math.random().toString(36).substr(2,6).split("").map(e=>Math.random()<Math.random()?e.toUpperCase():e).join().replaceAll(",","")).toUpperCase(),
                                  // folio : ""

                              }}
                            >
                              {({
                                handleSubmit,
                                handleChange,
                                setFieldValue,

                                values,
                                touched,
                                isValid,
                                errors,
                              }) => (

                                <Form id='my-form' noValidate onSubmit={handleSubmit}>






                                      <h2>{depto.departamento}</h2>
                                      
                                      <h6>Captura de Trámite</h6>

                                      <hr/>

                                      <div className="row">

                                      {
                                      
                                                                    //<div className="col-4">
                                      //
                                                                    //    <Form.Group >
                                                                    //      <Form.Label><i className="fa fa-asterisk obligatorios" /> Departamento</Form.Label>
                                                                    //      {
                                                                    //         deptos.map( depto =>
                                      //
                                                                    //        <Form.Check key={depto.uuid}
                                                                    //          required
                                                                    //          disabled={(values.iddepartamento!=="")}
                                                                    //          type="radio"
                                                                    //          name="iddepartamento"
                                                                    //          onChange={handleChange}
                                                                    //          isValid={touched.iddepartamento && !errors.iddepartamento}
                                                                    //          isInvalid={!!errors.iddepartamento}
                                                                    //          value={depto.uuid}
                                                                    //          label={depto.departamento}
                                                                    //          id={depto.uuid}
                                                                    //        />
                                      //
                                      //
                                                                    //        )
                                                                    //      }
                                      //
                                                                    //    <Form.Control.Feedback type="invalid">
                                                                    //      {errors.iddepartamento}
                                                                    //    </Form.Control.Feedback>
                                                                    //  </Form.Group >
                                      //
                                                                    //</div>
                                      }


                                          <div className="">

                                          {
                                            // JSON.stringify(depto)
                                          }


                                                  <React.Fragment>


                                                    {
                                                      !CIUDADANO_TRAMITE && (
                                                          <React.Fragment>
                                                              
                                                            <div className="d-grid gap-2">
                                                              <Button size="lg" variant="secondary" onClick={handleShowModalSolicitante}>
                                                                SELECCIONA UN SOLICITANTE
                                                              </Button>
                                                            </div>

                                                          </React.Fragment>
                                                      )
                                                    }

                                                    {
                                                      CIUDADANO_TRAMITE && (
                                                          <React.Fragment>

                                                            <h4>Solicitante</h4>

                                                            <h5>Información Personal</h5>

                                                            <div className="row">
                                                              <div className="col-sm-4">
                                                                  <b><small>Nombre</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.nombres}</p>
                                                              </div>
                                                              <div className="col-sm-4">
                                                                  <b><small>Apellido Paterno</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.paterno}</p>
                                                              </div>
                                                              <div className="col-sm-4">
                                                                  <b><small>Apellido Paterno</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.materno}</p>
                                                              </div>
                                                            </div>


                                                            <div className="row">
                                                              <div className="col-sm-3">
                                                                  <b><small>Fecha de Nacimiento</small></b>
                                                                  <p>{formatDate(CIUDADANO_TRAMITE.fecha_nacimiento)}</p>
                                                              </div>
                                                              <div className="col-sm-2">
                                                                  <b><small>Edad</small></b>
                                                                  <p>{getAge(CIUDADANO_TRAMITE.fecha_nacimiento)} AÑOS</p>
                                                              </div>
                                                              <div className="col-sm-4">
                                                                  <b><small>Sexo</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.sexo=='H'?'HOMBRE':'MUJER'}</p>
                                                              </div>
                                                            </div>


                                                            <div className="row">
                                                              <div className="col-sm-4">
                                                                  <b><small>CURP</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.curp}</p>
                                                              </div>
                                                              <div className="col-sm-4">
                                                                  <b><small>RFC</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.rfc}</p>
                                                              </div>
                                                              <div className="col-sm-4">
                                                                  <b><small>NSS</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.seguro_social}</p>
                                                              </div>
                                                            </div>



                                                            <h5>Información de Contacto</h5>

                                                            <div className="row">
                                                              <div className="col-sm-3">
                                                                  <b><small>Teléfono</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.telefono||'No Proporcionado'}</p>
                                                              </div>
                                                              <div className="col-sm-3">
                                                                  <b><small>Celular</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.celular||'No Proporcionado'}</p>
                                                              </div>
                                                              <div className="col-sm-6">
                                                                  <b><small>Correo Electrónico</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.email}</p>
                                                              </div>
                                                            </div>

                                                            <div className="row">
                                                              <div className="col-sm-6">
                                                                  <b><small>Dirección</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.direccion||'No Proporcionado'}</p>
                                                              </div>
                                                              <div className="col-sm-4">
                                                                  <b><small>Colonia</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.colonia||'No Proporcionado'}</p>
                                                              </div>
                                                              <div className="col-sm-2">
                                                                  <b><small>C.P.</small></b>
                                                                  <p>{CIUDADANO_TRAMITE.cp}</p>
                                                              </div>
                                                            </div>



                                                            <hr />




                                                                <h5 className="mt-4 mb-4">Requisitos del Trámite</h5>

                                                                {
                                                                  // JSON.stringify(currentUser.uuid)
                                                                }

                                                                

                                                                {
                                                                  currentUser.rol === "ROLE_ASISTENTE" && (
                                                                      <React.Fragment>
                                                                        {
                                                                          // JSON.stringify(asistentes_asesores)
                                                                        }


                                                                        <div className="mb-3">
                                                                          <label htmlFor="exampleFormControlInput1" className="form-label">Asesor</label>
                                                                          <select className="form-select" onChange={(e)=>{ setFieldValue('uuid_usuario_ayudo', (e.target.value || "").toUpperCase()) }} >
                                                                            <option value="" selected disabled>Selecciona un Asesor para asignar la captura</option>
                                                                            { asistentes_asesores.map( asesor => <option value={asesor.uuid}>{asesor.nombres} {asesor.paterno} {asesor.materno}</option>)}
                                                                          </select>
                                                                        </div>

                                                                      </React.Fragment>
                                                                    )
                                                                }



                                                                <Row className="mb-3">
                                                                  <Form.Group as={Col} md="6">
                                                                    <Form.Label>Folio *</Form.Label>
                                                                    <Form.Control
                                                                      required
                                                                      type="text"
                                                                      name="folio"
                                                                      value={values.folio}
                                                                      onChange={(e)=>{ setFieldValue('folio', (e.target.value || "").toUpperCase()) }}
                                                                      isValid={touched.folio && !errors.folio}
                                                                      isInvalid={!!errors.folio}
                                                                    />
                                                                      <Form.Control.Feedback type="invalid">
                                                                        {errors.folio}
                                                                      </Form.Control.Feedback>
                                                                  </Form.Group>
                                                                </Row>


                                                                <div className="row mb-3">
                                                                  <div className="col-sm-5">

                                                                        <label htmlFor="fecha_alta_anterior" className="form-label">Fecha de Alta del último Trabajo { !usuario_libre ? '*' : '' }</label>
                                                                        <DatePicker selected={estrategias_extra.fecha_alta_anterior} className="form-control" dateFormat="yyyy-MM-dd" maxDate={ new Date() } onChange={(date:Date) => setExtraDataEstrategias({ ...estrategias_extra, fecha_alta_anterior : date }) } />
                                                                      
                                                                  </div>
                                                                  <div className="col-sm-5">

                                                                        <label htmlFor="fecha_baja_anterior" className="form-label">Fecha de Baja del último Trabajo { !usuario_libre ? '*' : '' }</label>
                                                                        <DatePicker selected={estrategias_extra.fecha_baja_anterior} className="form-control" dateFormat="yyyy-MM-dd" maxDate={ new Date() } onChange={(date:Date) => setExtraDataEstrategias({ ...estrategias_extra, fecha_baja_anterior : date }) } />
                                                                      
                                                                  </div>
                                                                </div>




                                                                <div className="row">
                                                                  <div className="col-sm-6 mb-3">

                                                                    <label htmlFor="afore" className="form-label">Afore del Retiro { !usuario_libre ? '*' : '' }</label>
                                                                    <Form.Select id="afore" value={estrategias_extra.idafore} onChange={(e)=>{ setExtraDataEstrategias({ ...estrategias_extra, idafore : e.target.value }) }}>
                                                                          <option value={""}>Selecciona una opción</option>
                                                                      {
                                                                        afores.map( afore => 
                                                                          <option key={ Math.random().toString(36).substr(2, 9) } value={afore.uuid}>{(afore.afore)}</option>
                                                                        )
                                                                      }
                                                                    </Form.Select>




                                                                    



                                                                  </div>
                                                                </div>






                                                                  <div className="table-responsive">

                                                                      <table className="table ">
                                                                        <thead>
                                                                          <tr>
                                                                            <th>Requisito</th>
                                                                            <th></th>
                                                                            <th colSpan={2}>Anexo</th>
                                                                          </tr>
                                                                        </thead>
                                                                        <tbody>

                                                                        {
                                                                          requisitos_del_tramite.map( (requisito:any, index:number) =>

                                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                                <td className="v">
                                                                                  <small>{requisito.requisito}</small>
                                                                                </td>
                                                                                <td className="v" width="50">
                                                                                  { !usuario_libre && (<small>{requisito.obligatorio?'Obligatorio':''}</small>) }
                                                                                </td>
                                                                                <td className="v text-center" width="30">
                                                                                  {
                                                                                      requisito.anexo && (
                                                                                        <i className="fa fa-check-circle" />
                                                                                      ) 
                                                                                  }
                                                                                </td>
                                                                                <td className="v" width="400">
                                                                                {
                                                                                    !requisito.anexo && (
                                                                                      <input type="file" accept="application/pdf" onChange={(event)=>{ handleFileRead(event,index); }} />
                                                                                    ) 
                                                                                }
                                                                                  
                                                                                  {
                                                                                    requisito.anexo && (  

                                                                                      <p className="nm text-right">
                                                                                          <Button onClick={()=>{previewPDF(requisito.anexo)}} variant="link">Ver Anexo</Button>
                                                                                          <i onClick={(event)=>{ deleteFileRequisito(index);}} className="fa fa-trash"/>
                                                                                      </p>
                                                                                        
                                                                                    )
                                                                                  }

                                                                                </td>
                                                                              </tr>

                                                                            )
                                                                        }

                                                                        </tbody>
                                                                      </table>


                                                                  </div>




                                                                <hr />

                                                                <h5 className="mt-4 mb-4">Cobranza</h5>

                                                                <div className="row">

                                                                    <div className="col-sm-3 mb-3">
                                                                      <label htmlFor="monto_aseguramiento" className="form-label">Monto del Retiro { !usuario_libre ? '*' : '' }</label>
                                                                      <input type="number" className="form-control" id="monto_aseguramiento" value={estrategias_extra.monto_aseguramiento} onChange={(e)=>{ setExtraDataEstrategias({ ...estrategias_extra, monto_aseguramiento : e.target.value }) }} />
                                                                    </div>

                                                                    <div className="col-sm-3 mb-3">
                                                                        <label htmlFor="sindo" className="form-label">Fecha de SINDO</label>
                                                                        <DatePicker selected={estrategias_extra.sindo} className="form-control" dateFormat="yyyy-MM-dd" maxDate={ new Date() } onChange={(date:Date) => setExtraDataEstrategias({ ...estrategias_extra, sindo : date }) } />
                                                                    </div>

                                                                    <div className="col-sm-3 mb-3">
                                                                      <label htmlFor="semanas_cotizadas" className="form-label">Número de Semanas Cotizadas { !usuario_libre ? '*' : '' }</label>
                                                                      <input type="number" className="form-control" id="semanas_cotizadas" value={estrategias_extra.semanas_cotizadas} onChange={(e)=>{ setExtraDataEstrategias({ ...estrategias_extra, semanas_cotizadas : e.target.value }) }} />
                                                                    </div>

                                                                    <div className="col-sm-3 mb-3">
                                                                      <label htmlFor="semanas_cotizadas" className="form-label">Monto RCV { !usuario_libre ? '*' : '' }</label>
                                                                      <input type="number" className="form-control" id="monto_rcv" value={estrategias_extra.monto_rcv} onChange={(e)=>{ setExtraDataEstrategias({ ...estrategias_extra, monto_rcv : e.target.value }) }} />
                                                                    </div>

                                                                </div>

                                                                  {

                                                                    enviandoTramite && (
                                                                        <p><i className="fa fa-spin fa-spinner" /> Tú Trámite se esta guardando</p>
                                                                    )

                                                                  }

                                                                  {

                                                                    !enviandoTramite && (
                                                                        <div className="row mt-4">
                                                                            <div className="col-sm-8 mt-2 d-grid gap-3">
                                                                              <Button variant="primary" size="lg" onClick={(event)=>{crearExpediente(event)}} className="btn-block">Crear Nuevo Expediente</Button>
                                                                            </div>
                                                                            <div className="col-sm mt-2 d-grid gap-3">
                                                                              <Button variant="danger" size="lg" onClick={(event)=>{cancelarCaptura(event)}} className="btn-block">Cancelar Captura</Button>
                                                                            </div>
                                                                        </div>
                                                                    )

                                                                  }






                                                              
                                                          </React.Fragment>
                                                      )
                                                    }

                                                  </React.Fragment>






                                          </div>
                                            
                                      </div>


                                      </Form>
                              )}

                            </Formik>




                      </div>






                            <Formik
                              innerRef={formRef}
                              validationSchema={schema_persona}
                              onSubmit={()=>{}}
                              initialValues={{

                                  nombres : "",
                                  paterno : "",
                                  materno : "",
                                  
                                  curp : "",
                                  seguro_social : "",
                                  rfc : "",

                                  email : "",
                                  telefono : "",
                                  celular : "",

                                  direccion : "",
                                  colonia : "",
                                  cp : "",
                                  // curp : ((generateString(1)) +'APC'+ (Math.floor(Math.random() * 6) + 1) + (Math.floor(Math.random() * 6) + 1) +'1225MCCNNT0'+(Math.floor(Math.random() * 6) + 1)).trim(),

                              }}
                            >
                              {({
                                handleSubmit,
                                handleChange,
                                setFieldValue,

                                values,
                                touched,
                                isValid,
                                errors,
                                dirty

                              }) => (

                                <Form noValidate>


                  <Modal show={showModalSolicitante} onHide={handleCloseModalSolicitante}>
                    <Modal.Header closeButton>
                      <Modal.Title>Solicitante</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                                            <h5>Información Personal</h5>

                                            <Row className="mb-3">
                                                <Form.Group as={Col} md="12">
                                                  <Form.Label>CURP *</Form.Label>
                                                  <Form.Control
                                                    required
                                                    disabled={verifico_existencia_ciudadano}
                                                    type="text"
                                                    name="curp"
                                                    value={values.curp}
                                                    onChange={(e)=>{ setFieldValue('curp', (e.target.value || "").toUpperCase()) }}
                                                    isValid={touched.curp && !errors.curp}
                                                    isInvalid={!!errors.curp}
                                                  />
                                                    <Form.Control.Feedback type="invalid">
                                                      {errors.curp}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>

                                          {
                                            !verifico_existencia_ciudadano && (
                                                <Button className="mt-3" disabled={values.curp.length!==18} variant="secondary" onClick={()=>{verificacion_solicitante(values.curp)}}>
                                                  Verificar
                                                </Button>
                                            )
                                          }



                                          {
                                            (!errors.curp && values.curp !== "" && ciudadano_existe === false && verifico_existencia_ciudadano) && (
                                                <React.Fragment>
                                                          

                                                      <Row className="mb-3">
                                                        <Form.Group as={Col} md="12">
                                                          <Form.Label>Nombre(s) *</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="text"
                                                            name="nombres"
                                                            value={values.nombres}
                                                            onChange={(e)=>{ setFieldValue('nombres', (e.target.value || "").toUpperCase()) }}
                                                            isValid={touched.nombres && !errors.nombres}
                                                            isInvalid={!!errors.nombres}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.nombres}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>
                                                      <Row className="mb-3">
                                                          <Form.Group as={Col} md="6">
                                                            <Form.Label>Apellido Paterno *</Form.Label>
                                                            <Form.Control
                                                              required
                                                              type="text"
                                                              name="paterno"
                                                              value={values.paterno}
                                                              onChange={(e)=>{ setFieldValue('paterno', (e.target.value || "").toUpperCase()) }}
                                                              isValid={touched.paterno && !errors.paterno}
                                                              isInvalid={!!errors.paterno}
                                                            />
                                                              <Form.Control.Feedback type="invalid">
                                                                {errors.paterno}
                                                              </Form.Control.Feedback>
                                                          </Form.Group>
                                                          <Form.Group as={Col} md="6">
                                                            <Form.Label>Apellido Materno</Form.Label>
                                                            <Form.Control
                                                              type="text"
                                                              name="materno"
                                                              value={values.materno}
                                                              onChange={(e)=>{ setFieldValue('materno', (e.target.value || "").toUpperCase()) }}
                                                              isValid={touched.materno && !errors.materno}
                                                              isInvalid={!!errors.materno}
                                                            />
                                                              <Form.Control.Feedback type="invalid">
                                                                {errors.materno}
                                                              </Form.Control.Feedback>
                                                          </Form.Group>
                                                      </Row>


                                                      <Row className="mb-3">
                                                        <Form.Group as={Col} md="6">
                                                          <Form.Label>Sexo</Form.Label>
                                                          <Form.Control
                                                            disabled={true}
                                                            type="text"
                                                            value={values.curp.substr(10,1) == 'H' ? 'HOMBRE' : 'MUJER'}
                                                          />
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="6">
                                                          <Form.Label>Fecha de Nacimiento</Form.Label>
                                                          <Form.Control
                                                            disabled={true}
                                                            type="text"
                                                            value={moment(curp2date(values.curp)).format('YYYY-MM-DD')}
                                                          />
                                                        </Form.Group>
                                                      </Row>  

                                                      <Row className="mb-3">
                                                        <Form.Group as={Col} md="8">
                                                          <Form.Label>Número de Seguro Social *</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="text"
                                                            name="seguro_social"
                                                            value={values.seguro_social}
                                                            onChange={(e)=>{ setFieldValue('seguro_social', (e.target.value || "").toUpperCase()) }}
                                                            isValid={touched.seguro_social && !errors.seguro_social}
                                                            isInvalid={!!errors.seguro_social}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.seguro_social}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>  




                                                      <Row className="mb-3">
                                                        <Form.Group as={Col}>
                                                          <Form.Label><b>RFC</b> Registro Federal de Contribuyentes *</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="text"
                                                            name="rfc"
                                                            value={values.rfc}
                                                            onChange={(e)=>{ setFieldValue('rfc', (e.target.value || "").toUpperCase()) }}
                                                            isValid={touched.rfc && !errors.rfc}
                                                            isInvalid={!!errors.rfc}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.rfc}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>



                                                      <h5>Información de Contacto</h5>

                                                      <Row className="mb-3">
                                                        <Form.Group as={Col}>
                                                          <Form.Label>Correo Electrónico</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="email"
                                                            name="email"
                                                            value={values.email}
                                                            onChange={(e)=>{ setFieldValue('email', (e.target.value || "") ) }}
                                                            isValid={touched.email && !errors.email}
                                                            isInvalid={!!errors.email}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.email}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>

                                                      <Row className="mb-3">
                                                        <Form.Group as={Col} md="6">
                                                          <Form.Label>Teléfono</Form.Label>
                                                          <Form.Control
                                                            type="text"
                                                            name="telefono"
                                                            value={values.telefono}
                                                            onChange={(e)=>{ setFieldValue('telefono', (e.target.value || "") ) }}
                                                            isValid={touched.telefono && !errors.telefono}
                                                            isInvalid={!!errors.telefono}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.telefono}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                        <Form.Group as={Col} md="6">
                                                          <Form.Label>Celular</Form.Label>
                                                          <Form.Control
                                                            type="text"
                                                            name="celular"
                                                            value={values.celular}
                                                            onChange={(e)=>{ setFieldValue('celular', (e.target.value || "") ) }}
                                                            isValid={touched.celular && !errors.celular}
                                                            isInvalid={!!errors.celular}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.celular}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>





                                                      <Row className="mb-3">
                                                        <Form.Group as={Col}>
                                                          <Form.Label>Dirección</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="text"
                                                            name="direccion"
                                                            value={values.direccion}
                                                            onChange={(e)=>{ setFieldValue('direccion', (e.target.value || "").toUpperCase() ) }}
                                                            isValid={touched.direccion && !errors.direccion}
                                                            isInvalid={!!errors.direccion}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.direccion}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>




                                                      <Row className="mb-3">
                                                        <Form.Group as={Col} md="8">
                                                          <Form.Label>Colonia</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="text"
                                                            name="colonia"
                                                            value={values.colonia}
                                                            onChange={(e)=>{ setFieldValue('colonia', (e.target.value || "").toUpperCase() ) }}
                                                            isValid={touched.colonia && !errors.colonia}
                                                            isInvalid={!!errors.colonia}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.colonia}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} md="4">
                                                          <Form.Label>CP</Form.Label>
                                                          <Form.Control
                                                            required
                                                            type="text"
                                                            name="cp"
                                                            value={values.cp}
                                                            onChange={(e)=>{ setFieldValue('cp', (e.target.value || "") ) }}
                                                            isValid={touched.cp && !errors.cp}
                                                            isInvalid={!!errors.cp}
                                                          />
                                                            <Form.Control.Feedback type="invalid">
                                                              {errors.cp}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                      </Row>







                                                </React.Fragment>

                                           )
                                        }

                                        {
                                          ciudadano_existe && (
                                            <React.Fragment>
                                                {
                                                  // JSON.stringify(SOLICITANTE)
                                                }


                                                  <dl className="row mt-4">
                                                    <dt className="col-sm-3">N.S.S.:</dt>
                                                    <dd className="col-sm-8">{SOLICITANTE.seguro_social}</dd>

                                                    <dt className="col-sm-3">Nombre(s):</dt>
                                                    <dd className="col-sm-8">{SOLICITANTE.nombres}</dd>

                                                    <dt className="col-sm-3">Paterno:</dt>
                                                    <dd className="col-sm-9">{SOLICITANTE.paterno}</dd>

                                                    <dt className="col-sm-3">Materno:</dt>
                                                    <dd className="col-sm-9">{SOLICITANTE.materno}</dd>

                                                    <dt className="col-sm-3">Sexo:</dt>
                                                    <dd className="col-sm-9">{SOLICITANTE.sexo=='M'?'MUJER':'HOMBRE'}</dd>

                                                    <dt className="col-sm-3">Fecha de Nacimiento:</dt>
                                                    <dd className="col-sm-9">{moment(curp2date(SOLICITANTE.curp)).format('YYYY-MM-DD')}</dd>
                                                  </dl>


                                                  <h5 className="mt-4">Información de Contacto</h5>


                                                  <div className="mb-3">
                                                    <label className="form-label">Correo Electrónico</label>
                                                    <input type="text" className="form-control" value={SOLICITANTE.email} onChange={(e)=>{ setSolicitante( { ...SOLICITANTE, email : e.target.value } ) }} />
                                                  </div>

                                                  <div className="row">
                                                    <div className="col-6">
                                                        <div className="mb-3">
                                                          <label className="form-label">Número de Celular</label>
                                                          <input type="text" className="form-control" value={SOLICITANTE.celular} onChange={(e)=>{ setSolicitante( { ...SOLICITANTE, celular : e.target.value } ) }} />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mb-3">
                                                          <label className="form-label">Número de Teléfono</label>
                                                          <input type="text" className="form-control" value={SOLICITANTE.telefono} onChange={(e)=>{ setSolicitante( { ...SOLICITANTE, telefono : e.target.value } ) }} />
                                                        </div>
                                                    </div>
                                                  </div>



                                                  <h5 className="mt-4">Información de Localización</h5>


                                                  <div className="mb-3">
                                                    <label className="form-label">Dirección</label>
                                                    <input type="text" className="form-control" value={SOLICITANTE.direccion} onChange={(e)=>{ setSolicitante( { ...SOLICITANTE, direccion : e.target.value.toUpperCase() } ) }} />
                                                  </div>




                                                  <div className="row">
                                                    <div className="col-8">
                                                        <div className="mb-3">
                                                          <label className="form-label">Colonia</label>
                                                          <input type="text" className="form-control" value={SOLICITANTE.colonia} onChange={(e)=>{ setSolicitante( { ...SOLICITANTE, colonia : e.target.value.toUpperCase() } ) }} />
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="mb-3">
                                                          <label className="form-label">C. P.</label>
                                                          <input type="number" className="form-control" value={SOLICITANTE.cp} onChange={(e)=>{ setSolicitante( { ...SOLICITANTE, cp : e.target.value } ) }} />
                                                        </div>
                                                    </div>
                                                  </div>





                                                  <div className="row">
                                                      <div className="col-md-8">
                                                          <div className="d-grid gap-2 mt-2">
                                                              <Button variant="info" onClick={(e)=>{actualizarDatosCiudadano(e)}}>
                                                                  Guardar y Continuar <i className="fa fa-save" />
                                                              </Button>
                                                          </div>
                                                      </div>
                                                      <div className="col-md-4">
                                                          <div className="d-grid gap-2 mt-2">
                                                              <Button variant="danger" onClick={()=>{seleccionarCiudadanoOtraVez()}}>
                                                                  NO
                                                              </Button>
                                                          </div>
                                                      </div>
                                                  </div>




                                            </React.Fragment>
                                          )
                                        }




                                        {
                                          (!ciudadano_existe && verifico_existencia_ciudadano) && (

                                                <div className="row">
                                                    <div className="col-md-9">
                                                        <div className="d-grid">
                                                            <Button variant="primary" type="button" disabled={!(dirty && isValid)} onClick={()=>{agregarNuevoSolicitante(formRef.current.values)}} >
                                                                <i className="fa fa-fast-forward" />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="d-grid">
                                                            <Button variant="success" type="button" onClick={(e)=>{cancelarTramite(e)}} >
                                                                <small>CANCELAR</small>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>

                                          )
                                        }





                                        </Modal.Body>



                  </Modal>




                                 </Form>

                              )}

                            </Formik>







                            <Modal show={showPreview} fullscreen={true} onHide={handleClosePreview}>

                              <Modal.Header closeButton>
                                <Modal.Title>Requisito</Modal.Title>
                              </Modal.Header>

                              <Modal.Body>
                                {
                                  // <p>{anexo_preview}</p>
                                }

                                  <object data={anexo_preview} type="application/pdf" width="100%" height="900">
                                    <p>It appears you don't have a PDF plugin for this browser.
                                    No biggie... you can <a href="http://www.example.com/the.pdf">click here to
                                    download the PDF file.</a></p>
                                  </object>



                              </Modal.Body>

                            </Modal>




          </div>
        </div>
      </div>

    </React.Fragment>

      );
  

}

export default Tramites
